import { Popup } from 'semantic-ui-react';
import redirectTo from '../../../utils/redirectTo';
import { AchievementData } from '../types';
import styles from './styles.module.scss';
import { getAchCategory } from '../utils';

export const TakenAchievements = ({
  takenAchievements
}: {
  takenAchievements: AchievementData[]
}) => {
  const count = takenAchievements.length;

  return (
    <div className={styles.TakenAchievements}>
      {
        takenAchievements.slice(0, 4).map((ach, i) => (
          <Popup
            inverted
            openOnTriggerClick={true}
            openOnTriggerMouseEnter={true}
            openOnTriggerFocus={true}
            basic
            style={{ backgroundColor: "#333333" }}
            position={"top center"}
            trigger={
              <div className={styles.TakenAchievements_ach} onClick={() => redirectTo('/profile/achievements')}>
                <img src={`/static/images/achievements/${getAchCategory(ach.type)}/${ach.type}.png`} alt={ach.name} width={54} height={54} />
                {
                  (i === takenAchievements.slice(0, 4).length - 1 && count > 4) &&
                  <div className={styles.TakenAchievements_ach__blur}>
                    <span>+ {count - 4}</span>
                  </div>
                }
              </div>
            }
          >
            {ach.name}
          </Popup>
        ))
      }
    </div>
  );
};
